<template>
    <div class="page-audit audit-equipment-create layout-max-width">

        <!--        NB: The purpose of the spinner is just for when they save the form, to prevent flashing back to the list page-->
        <spinner-until :condition="!saving">
            <data-form title="Add Equipment to Audit"
                       save-button-label="Continue"
                       cancel-button-label="Back to Equipment List"
                       :field-model="auditEquipmentFields"
                       :field-groups="fieldGroups"
                       :on-submit-handler="onSubmit"
                       :cancelRoute="returnRoute"
                       :load-model-instance="loadModelInstance"
                       submit-success-message="Equipment Added"
                       submit-error-message="Error Adding Equipment to Audit"
                       @changed="changed"/>

            <equipment-view-details
                :equipment="equipment"/>
        </spinner-until>
    </div>
</template>

<script>

import AuditEquipmentFields from '@/models/AuditEquipment'

export default {
    name: 'AuditEquipmentCreate',
    props: {
        auditId: Number,
    },
    data () {
        return {
            auditEquipmentFields: AuditEquipmentFields,
            fieldGroups: [
                ['equipment', 'statusCreate'],
            ],
            equipment: null,
            saving: false,
        }
    },
    computed: {
        returnRoute () {
            return `/audit/edit/${this.auditId}`
        },
    },
    methods: {
        onSubmit (modelInstance) {

            this.saving = true
            modelInstance.audit_id = this.auditId

            this.$api.createItem(this, 'audit-equipment', modelInstance)
                .then((response) => {
                    if (modelInstance.status === 'NO_ISSUE') {
                        this.$router.push(`/auditEquipment/create/${this.auditId}`)
                    } else {
                        this.$router.push(`/auditEquipment/edit/${this.auditId}/${response.body.id}`)
                    }
                    this.saving = false
                }, (error) => {
                    this.$toasted.show('There was an error adding equipment to this audit')
                })

        },
        loadModelInstance () {
            //Inject the audit_id into the model so that the
            //multi-select's doSearch function has access to it when searching equipment
            return new Promise((resolve, reject) => {
                const instance = {
                    audit_id: this.auditId
                }
                resolve(instance)
            })
        },
        changed (fieldName, form) {
            this.equipment = form.equipment
        }
    }
}
</script>

<style scoped>

</style>